import { Divider, VStack, DataList, DataItem } from '@cad-arc';
import { ReactivationDto } from '@mark43/cad-api';
import { SectionTitle } from '../../fr-event-common-components/section-title';
import { formatMonthDayYearHoursMinutesSeconds } from '../../common/helpers/utils';

export function FrDispositionSection({
    dispositionDateUtc,
    reactivation,
    additionalDispositionsEnabled,
    primaryDisposition,
    additionalDisposition,
    comments,
}: {
    dispositionDateUtc?: string;
    reactivation?: ReactivationDto;
    additionalDispositionsEnabled: boolean;
    primaryDisposition?: string;
    additionalDisposition?: string;
    comments?: string;
}) {
    const dispositionDate = dispositionDateUtc
        ? formatMonthDayYearHoursMinutesSeconds(dispositionDateUtc)
        : '-';

    const reactivationsData = {
        createdDate: reactivation?.createdDateUtc
            ? formatMonthDayYearHoursMinutesSeconds(reactivation.createdDateUtc)
            : '-',
        comments: reactivation?.reason ?? '',
    };

    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title="Dispositions" />
            <DataList>
                <DataItem dataKey="Primary">
                    {`${dispositionDate} ${primaryDisposition ?? ''}`}
                </DataItem>
                {additionalDispositionsEnabled && (
                    <DataItem dataKey="Additional">
                        {`${dispositionDate} ${additionalDisposition ?? ''}`}
                    </DataItem>
                )}
                <DataItem dataKey="Comments">{comments ?? ''}</DataItem>
            </DataList>
            <Divider style={{ marginTop: '16px' }} />
            <SectionTitle title="Reactivation" />
            <DataList>
                <DataItem dataKey="Primary">{reactivationsData.createdDate}</DataItem>
                <DataItem dataKey="Comments">{reactivationsData.comments}</DataItem>
            </DataList>
        </VStack>
    );
}
